import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Card as MuiCard, CardHeader, CardContent, CardActions, createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function () {
  return createStyles({
    content: {
      margin: 0,
      padding: 0
    }
  });
});

var Card = function Card(_ref) {
  var id = _ref.id,
      e2e = _ref.e2e,
      header = _ref.header,
      body = _ref.body,
      footer = _ref.footer,
      getHeaderSlot = _ref.getHeaderSlot,
      getBodySlot = _ref.getBodySlot,
      getFooterSlot = _ref.getFooterSlot,
      fullWidth = _ref.fullWidth;
  var classes = useStyles();
  var headerCb = React.useCallback(function (node) {
    getHeaderSlot && getHeaderSlot(node);
  }, [getHeaderSlot]);
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  var footerCb = React.useCallback(function (node) {
    getFooterSlot && getFooterSlot(node);
  }, [getFooterSlot]);
  var hasHeader = Boolean(header || getHeaderSlot);
  var hasBody = Boolean(body || getBodySlot);
  var hasFooter = Boolean(footer || getFooterSlot);
  var headerId = "".concat(id, "-header");
  var bodyId = "".concat(id, "-body");
  return /*#__PURE__*/React.createElement(MuiCard, _extends({}, hasHeader && {
    'aria-labelledby': headerId
  }, hasBody && {
    'aria-describedby': bodyId
  }, e2e && {
    'data-e2e': e2e
  }), hasHeader && /*#__PURE__*/React.createElement(CardHeader, _extends({
    id: headerId,
    ref: headerCb,
    title: header
  }, e2e && {
    'data-e2e': "".concat(e2e, "-header")
  })), hasBody && /*#__PURE__*/React.createElement(CardContent, _extends({
    className: fullWidth ? classes.content : undefined,
    ref: bodyCb,
    id: bodyId
  }, e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }), body), hasFooter && /*#__PURE__*/React.createElement(CardActions, _extends({
    ref: footerCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-footer")
  }), footer));
};

export default Card;

try {
  Card.__docgenInfo = {
    description: '',
    displayName: 'Card',
    methods: [],
    props: {
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      footer: {
        defaultValue: null,
        description: '',
        name: 'footer',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      getFooterSlot: {
        defaultValue: null,
        description: '',
        name: 'getFooterSlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      getHeaderSlot: {
        defaultValue: null,
        description: '',
        name: 'getHeaderSlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      header: {
        defaultValue: null,
        description: '',
        name: 'header',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      id: {
        defaultValue: null,
        description: 'Unique ID for accessibility purposes.',
        name: 'id',
        required: true,
        type: {
          name: 'string'
        }
      },
      fullWidth: {
        defaultValue: null,
        description: '',
        name: 'fullWidth',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map